<template>
    <div class="col-md-12">
        <navbar v-if="!opignoMode" placement="top" container="fluid">
                <div class="buttons-navbar-left" slot="left">
                    <button :disabled="backDisabled" class="btn btn-primary" @click="back()" v-if="navbarData">{{ previousText }}</button>
                </div>
                <div style="display:inline-block" class="buttons-navbar-right" slot="right">
                    <div style="display:inline-block" v-if="hasButtons">
                        <div style="display:inline-block" v-for="buttonDatum in navbarData.buttonData">
                            <a v-if="buttonDatum.link" class="btn btn-primary" :target="buttonDatum.linkTarget" :href="buttonDatum.link" style="margin-right:0.5em">{{ buttonDatum.text }}</a>
                            <button v-else :disabled="!buttonDatum.actionToCall" class="btn btn-primary" @click="buttonDatum.actionToCall()" style="margin-right:0.5em">
                                {{ buttonDatum.text }}
                            </button>
                        </div>
                    </div>
                     <button class="btn btn-primary" @click="logout()">Déconnexion</button>
                </div>
        </navbar>
        <router-view class="col-md-10 col-md-offset-1" @navbarUpdate="onNavbarUpdate"></router-view>
    </div>
</template>

<script>
import { navbar as Navbar } from 'vue-strap'

export default {
    components: {
        Navbar
    },
    computed: {
        opignoMode: function()  {
            return this.$store.state.opignoMode;
        },
    	previousText: function()	{
    		if (this.navbarData.backText)	{
    			return this.navbarData.backText != "" ? this.navbarData.backText : 'Retour';
    		}

			return 'Retour';    			
    	},
        hasButtons: function() {
            if (this.navbarData)    {
                if (this.navbarData.buttonData) {
                    return true;
                }
            }

            return false;
        }
    },
    methods: {
        onNavbarUpdate(navbarData)    {
            this.navbarData = navbarData;
        },
        back()  {
            if (this.navbarData.pathData)    {
                this.$router.push(this.navbarData.pathData);
            }
            else    {
                this.$router.back();
            }
            this.$nextTick(function()   {
                this.backDisabled = true;
            });
        },
        logout()    {
            this.$store.commit('TOKEN_UPDATED', {newToken: "", newRefreshToken: ""});
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            this.$router.push('/');
        },
        refreshToken()  {
            let self = this;
            setTimeout(function() {
                let successCallback = (data) => {
                    self.$store.commit('TOKEN_UPDATED', {newToken: data.token, newRefreshToken: data.refresh_token});
                };

                let failCallback = (data) => {
                    self.$store.commit('TOKEN_UPDATED', {newToken: "", newRefreshToken: ""});
                    self.$router.push('/');
                };

                self.$store.dispatch('userRefresh', {success: successCallback, fail: failCallback, error: failCallback});
                self.refreshToken();
            }, 3600000);
        }
    },
    data: function()  {
        return {
            navbarData: null,
            backDisabled: false
        };
    },
    beforeCreate()  {
        this.$router.afterEach((to, from) => {
			this.navbarData = null;
            this.backDisabled = false;
            this.$Progress.finish();
        })
    },
    mounted()   {
        this.refreshToken();
    }
}

</script>

<style>
.buttons-navbar-left   {
    margin-top:0.5em;
}

.buttons-navbar-right   {
    margin-top:0.5em;
    margin-right:1em;
}
</style>
